import { MarketEnum } from './../../model/enum/market.enum';
import { ISuitabilityLoggable } from './../strategy-pattern-login/iSuitability-loggable';
import { Injectable } from '@angular/core';
import { Observable , of } from 'rxjs';
import { ConfigService } from './config.service';
import { HttpService } from '../http-service';
import { Constants } from '@utils/constants';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ISuitabilityAdapterService implements ISuitabilityLoggable {

  public _suitabilityPerfilI = [];

  constructor(
    private _configService: ConfigService,
    private _httpService: HttpService,
  ) { }

  suitabilityCheckMatrix(account: string, marketID: MarketEnum, securityType: string, securityRisk: number,
    symbol: string, suitabilityID?: string, profileName?: string, client_id?: number) {
    if (this._configService.isUserAssessorLogged() && (!suitabilityID)) {
      return new Observable<any>(observer => {
        const json = { res: false, code: 400, message: 'Perfil não encontrado!' };
        observer.next(json);
      });
    } else if (!suitabilityID) {
      return new Observable<any>(observer => {
        const json = { res: false, code: 400, message: 'Perfil não encontrado!' };
        observer.next(json);
      });
    }
    const params = {
      market_id: +marketID == MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF,
      security_type: securityType ? securityType : '',
      symbol: symbol ? symbol.toUpperCase() : null,
      security_risk: securityRisk.toString(),
      suitability_id: suitabilityID
    };
    return this._httpService
      .doPostWso2(this._configService.getTermSuitabilityURL(), 'terms/term', params, null, null, false, true)
      .pipe(map(res => {
        return res;
      }));
  }

  postAssignBounds(account: string, symbol: string, client_id: number, user_id: number, marketID: MarketEnum, securityType: string) {
    const params = {
      market_id: marketID === MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF,
      security_type: securityType,
      Symbol: symbol ? symbol.toUpperCase() : null
    };
    return this._httpService
      .doPostWso2(this._configService.getTermSuitabilityURL(), 'terms/sign', params, null, null, false, true)
      .pipe(map(res => {
        if (res) {
          return res.signed;
        }
        return [];
      }));
  }

  suitabilityPerfilInformation(getPerfil?: boolean) {
    if (getPerfil && !this._configService.isUserAssessorLogged()) {
      if (this._suitabilityPerfilI && this._suitabilityPerfilI.length === 0 || !this._suitabilityPerfilI.length) {
        return this._httpService
          .doGet(this._configService.getApiWebFeederRest(), 'services/negotiation/suitabilityPerfilInformation')
          .pipe(map(response => {
            if (response) {
              this._suitabilityPerfilI = response.suitabilitys;
              return this._suitabilityPerfilI;
            }
            return [];
          }));
      } else {
        return this._suitabilityPerfilI;
      }
    } else {
      return of([]);
    }
  }

  getTermsUse(account: string) {
    if (!account) {
      return of([]);
    }
    return this._httpService
      .doGet(this._configService.getTermSuitabilityURL(), 'terms_use/terms?user=' + account)
      .pipe(map(res => {
        return res;
      }));
  }

  postTermsUse(params: any) {
    if (!params) {
      return of([]);
    }
    return this._httpService
      .doPostWso2(this._configService.getTermSuitabilityURL(), 'terms_use/sign', params, null, null, false, true)
      .pipe(map(res => {
        return res;
      }));
  }

}
